var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{ref:"el",staticClass:"form-control multiselect",class:_vm.btnClass,attrs:{"multiple":"","data-non-selected-text":_vm.nonSelectedText}},_vm._l((_vm.options),function(opt){return _c('option',{domProps:{"value":opt.value,"selected":_vm.isSelected(opt)}},[_vm._v(_vm._s(opt.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }